import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { IUIConfiguration } from "../model"
import { UiConfigFontSelector } from "./UiConfigFontSelector"
import { UiConfigFontWeight } from "./UiConfigFontWeight"

interface IUiConfigFontProps {
  uiConfig: IUIConfiguration
}

export const UiConfigFont = React.memo(({ uiConfig }: IUiConfigFontProps) => (
    <FlexBox vertical gap jc="start">
      <UiConfigFontSelector uiConfig={uiConfig} />
      <UiConfigFontWeight uiConfig={uiConfig} configKey="weightLight" />
      <UiConfigFontWeight uiConfig={uiConfig} configKey="weightRegular" />
      <UiConfigFontWeight uiConfig={uiConfig} configKey="weightMedium" />
      <UiConfigFontWeight uiConfig={uiConfig} configKey="weightBold" />
    </FlexBox>
  ))
